export const HSPACE = 10;
export const SPACE = 20;
export const SPACE_2X = 40;
export const SPACE_3X = 60;
export const SPACE_4X = 80;

export const SPACE_6X = 120;